import React from 'react';
import logo from '../assets/AUSM-LOGO.png';

const FinancialPolicyPages = ({ formData, PageContainer, appId }) => {
    const guardianAddress = [
        formData?.address?.area?.value ? `منطقة ${formData.address.area.value}` : "",
        formData?.address?.block?.value ? `قطعة ${formData.address.block.value}` : "",
        formData?.address?.street?.value ? `شارع ${formData.address.street.value}` : ""
    ].filter(Boolean).join(" - ");

    const SigField = ({ label, value, fullWidth = false, isWideLabel = false, lineColor = "border-black", variant = "box" }) => (
        <div className={`flex items-baseline w-full mb-1 gap-2`} dir="rtl">
            <span className="font-bold text-[11px] text-gray-800 whitespace-nowrap flex-shrink-0 text-right">
                {label}
            </span>
            <div className={`flex-1 border-black ${variant === 'box' ? 'border-2' : 'border-b-2'} ${lineColor} min-h-[32px] flex items-center px-2 bg-white`}>
                <span className="text-blue-700 font-bold text-[11px] break-words w-full text-right pb-1">
                    {value || ""}
                </span>
            </div>
        </div>
    );

    // High-fidelity custom header for Financial Policy
    const FinancialHeader = (
        <div className="w-full mb-6">
            <div className="w-full border-b-[4px] border-[#b60041] pb-3 pt-2" dir="ltr">
                <div className="flex items-start justify-between w-full">
                    {/* LEFT LOGO */}
                    <div className="w-[190px] flex justify-start">
                        <img
                            src={logo}
                            alt="AUMS Logo"
                            className="h-[80px] w-auto object-contain"
                        />
                    </div>

                    {/* CENTER TITLE */}
                    <div className="flex-1 text-center px-4">
                        <h1
                            className="text-[#1e3a8a] font-bold leading-tight"
                            style={{ fontSize: "20px", whiteSpace: "nowrap" }}
                        >
                            American University for Medical Sciences
                        </h1>
                        <p
                            className="text-[#1e3a8a] font-bold mt-2 text-center"
                            dir="rtl"
                            style={{ fontSize: "20px" }}
                        >
                            الجامعة الامريكية للعلوم الطبية
                        </p>
                    </div>

                    {/* RIGHT BOXES */}
                    <div className="w-[190px] flex flex-col items-end gap-1">
                        <div
                            className="bg-[#ffcc00] border border-black font-extrabold text-center text-[12px] w-full py-1 shadow-sm"
                        >
                            Self-Funded Only
                        </div>
                        <div
                            className="bg-[#efb08d] border border-black font-bold text-center text-[20px] w-full py-1"
                        >
                            FORM C
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <>
            {/* PAGE 9: FINANCIAL POLICY PART 1 */}
            <PageContainer pageNum={9} customHeader={FinancialHeader}>
                <div className="text-right" dir="rtl">
                    {/* <div className="bg-gray-100 p-3 text-center mb-6 border border-gray-300 rounded-md">
                        <p className="font-bold text-[14px] text-gray-800">إقرار وتعهد بتسديد الرسوم والإلتزام بسياسة الإسترداد في حالة القبول</p>
                        <p className="font-bold text-[14px] text-gray-800">في برنامج بكالوريوس طب الأسنان</p>
                        <p className="font-bold text-[14px] text-[#b60041]">2026/2027</p>
                    </div> */}


                    <div className="p-4 mb-4 border-b-2 border-gray-100 flex flex-col items-center justify-center text-center">

                        <p className="font-bold text-[14px] text-gray-800 leading-7">
                            إقرار وتعهد بتسديد الرسوم والإلتزام بسياسة الإسترداد في حالة القبول
                        </p>

                        <p className="font-bold text-[14px] text-gray-800 leading-7">
                            في برنامج بكالوريوس طب الأسنان
                        </p>

                        <p className="font-bold text-[14px] text-[#b60041] leading-7">
                            2026/2027
                        </p>

                    </div>


                    <p className="text-red-700 font-bold border-b-2 border-red-700/40 pb-1.5 inline-block mb-4">أولاً : الرسوم والمبالغ (الغير قابلة للاسترداد) :</p>
                    <div className="pr-4 mb-4 text-[11px] leading-relaxed">
                        <p>1- رسوم التقديم: 20 دينار كويتي (تدفع مرة واحدة)</p>
                        <p>2- رسوم اختبارات القبول: 5 دينار لكل اختبار (تدفع مرة واحدة)</p>
                        <p>3- رسوم التسجيل: 150 دينار كويتي (لكل فصل دراسي) وتخصم من الرسوم الدراسية المدفوعة للفصل الدراسي</p>
                        <p>4- مبلغ حجز المقعد الدراسي: 1500 دينار كويتي (يُسدد مرة واحدة عند القبول، ويُخصم من الرسوم الدراسية للفصل الدراسي الذي تم القبول فيه بالجامعة)</p>
                    </div>

                    <p className="text-red-700 font-bold border-b-2 border-red-700/40 pb-1.5 inline-block mb-4">ثانياً : الرسوم الدراسية:</p>
                    <div className="pr-4 mb-4 text-justify text-xs leading-relaxed">
                        <p>- عند الترشيح للقبول في الجامعة، يلتزم الطالب بسداد مبلغ حجز المقعد الدراسي (غير قابل للاسترداد)، بالإضافة إلى كامل رسوم الفصل الدراسي الذي تم القبول فيه بالجامعة، وذلك قبل إرسال رسالة القبول عبر البريد الإلكتروني. وفي حال عدم الالتزام بالسداد خلال المدة المحددة والمذكورة في البلاغ، يُعدّ الترشيح ملغيًا تلقائيًا دون الحاجة إلى إشعار أو إنذار مسبق.</p>
                        <p>- للفصول الدراسية المتتالية: يجب دفع الرسوم الدراسية لكل فصل دراسي بالكامل خلال ثلاثين يوم من تاريخ ارسال اشعار طلب الدفع لاستكمال التسجيل.</p>
                    </div>

                    <table className="w-full border-collapse border border-black mb-4 text-center text-xs table-fixed" dir="rtl">
                        <thead>
                            <tr className="bg-[#cceaff] text-black font-bold">
                                <th className="border border-black p-2 w-[35%] text-center">الرسوم الدراسية</th>
                                <th className="border border-black p-2 w-[30%] text-center">الحد الأدنى لعدد الساعات المعتمدة المطلوبة للتخرج</th>
                                <th className="border border-black p-2 w-[35%] text-center">المعدل المطلوب للتخرج</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="font-bold bg-white text-center">
                                <td className="border border-black p-2 leading-relaxed break-words text-center">* 360 دينار كويتي لكل ساعة معتمدة</td>
                                <td className="border border-black p-2 text-center">215</td>
                                <td className="border border-black p-2 leading-relaxed break-words text-center">معدل تراكمي (CGPA) لا يقل عن 2.00</td>
                            </tr>
                        </tbody>
                    </table>

                    <div className="text-xs mb-4 font-bold leading-tight">
                        <p>* تحتفظ الجامعة بحقها في تغيير الرسوم الدراسية خلال فترة الدراسة بعد موافقة مجلس الجامعات الخاصة.</p>
                        <p>* في حال تعديل الرسوم الدراسية من قبل مجلس الجامعات الخاصة – سوف يتم تطبيق التعديل على الرسوم الدراسية لجميع الطلاب.</p>
                        <p>* الرسوم الدراسية المذكورة أعلاه لا تشمل رسوم أو تكاليف الكتب والمواد الاستهلاكية والأدوات والخدمات.</p>
                        <p>* إعادة المقررات الدراسية: تطبق الرسوم الدراسية كاملة على المقررات المكررة لأي سبب من الأسباب.</p>
                    </div>

                    <p className="text-red-700 font-bold border-b-2 border-red-700/40 pb-1.5 inline-block mb-4">ثالثاً : الشروط العامة :</p>
                    <div className="pr-4 mb-4 text-xs leading-relaxed">
                        <p>- يلتزم الطالب بالتسجيل وفق عدد الساعات المعتمدة المحددة في الخطة الدراسية للبرنامج.</p>
                        <p>- التكاليف الإضافية: جميع المواد والأدوات والأجهزة الاستهلاكية الخاصة باستخدامات الطالب نفسه في المختبرات والعيادات التدريبية خلال فترة الدراسة في الجامعة تكون على نفقة الطالب الخاصة.</p>
                        <p>- تعديلات الرسوم: تحتفظ الجامعة بالحق في تعديل الرسوم بموافقة مجلس الجامعات الخاصة في الكويت ومجلس أمناء الجامعة.</p>
                    </div>

                    <p className="text-red-700 font-bold border-b-2 border-red-700/40 pb-1.5 inline-block mb-4">رابعاً : عدم التزام الطالب بدفع الرسوم الدراسية :</p>
                    <div className="pr-4 mb-4 text-xs leading-relaxed">
                        <p>يترتب على عدم دفع الرسوم الدراسية وفقًا للبند الثاني وفي الوقت الزمني المحدد أعلاه إلغاء تسجيل الطالب في الفصل الدراسي الحالي أو القادم لحين سداد المديونية واتخاذ الجامعة الإجراءات القانونية اللازمة.</p>
                    </div>

                    <div className="mb-4">
                        <p className="text-red-700 font-bold border-b-2 border-red-700/40 pb-1.5 inline-block">خامساً : سياسة الاسترداد :</p>
                    </div>
                    <p className="border-b-2 border-gray-400 pb-1 mb-2 font-bold text-xs inline-block">1- القواعد العامة:</p>
                    <div className="pr-4 mb-4 text-xs leading-relaxed text-justify">
                        <p>- يتم احتساب الرسوم المستردة بناءً على مجمل الرسوم الدراسية المستحقة على الطالب (لا تشمل الرسوم والمبالغ الغير قابلة للاسترداد).</p>
                        <p>- على الطالب الالتزام بسياسة استرداد الرسوم.</p>
                        <p>- تنطبق سياسة الاسترداد على الرسوم الدراسية فقط وأي رسوم أخرى فهي غير قابلة للاسترداد.</p>
                        <p>- الطالب المفصول لأي سبب من الأسباب لا يسترد أي من الرسوم الدراسية أو الإضافية المدفوعة.</p>
                        <p>- في حال إلغاء أو إيقاف البرنامج الدراسي لأي سبب، يحق للطالب استرداد الرسوم الدراسية التي تم سدادها للجامعة عن الفصل الدراسي الذي تم فيه الإلغاء أو الإيقاف فقط، ولا تشمل أي فصول دراسية سابقة.</p>
                        <p>- لا تسترد أي رسوم دراسية لطالب تم إلغاء قيده.</p>
                    </div>
                </div>
            </PageContainer>

            {/* PAGE 10: FINANCIAL POLICY PART 2 */}
            <PageContainer pageNum={10}>
                <div className="text-right" dir="rtl">
                    <p className="text-red-700 font-bold border-b-2 border-red-700/40 pb-1.5 inline-block mb-4 leading-relaxed">2- Course Drop - في حال سحب مقررات لجميع الفصول الدراسية (ماعدا الفصل الصيفي) بعد السنة الدراسية الأولى:</p>
                    <table className="w-full border-collapse border border-black mb-4 text-center text-xs table-fixed" dir="rtl">
                        <thead>
                            <tr className="bg-[#b3b3b3] text-black font-bold text-center">
                                <th className="border border-black p-2 w-[45%] text-center">الفترة الزمنية</th>
                                <th className="border border-black p-2 w-[55%] text-center">استرداد الرسوم (فصلي الخريف والربيع)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="font-bold bg-white text-center">
                                <td className="border border-black p-2 leading-tight break-words text-center">خلال الأسبوع الأول من الفصل الدراسي</td>
                                <td className="border border-black p-2 leading-tight break-words text-center">استرداد 75% من المقرر المنسحب منه</td>
                            </tr>
                            <tr className="font-bold bg-[#f9f9f9] text-center">
                                <td className="border border-black p-2 leading-tight break-words text-center">خلال الأسبوع الثاني من الفصل الدراسي</td>
                                <td className="border border-black p-2 leading-tight break-words text-center">استرداد 50% من المقرر المنسحب منه</td>
                            </tr>
                            <tr className="font-bold bg-white text-center">
                                <td className="border border-black p-2 leading-tight break-words text-center">خلال الأسبوع الثالث من الفصل الدراسي</td>
                                <td className="border border-black p-2 leading-tight break-words text-center">استرداد 25% من المقرر المنسحب منه</td>
                            </tr>
                            <tr className="font-bold bg-[#f9f9f9] text-center">
                                <td className="border border-black p-2 leading-tight break-words text-center">بعد الأسبوع الثالث من الفصل الدراسي</td>
                                <td className="border border-black p-2 leading-tight break-words text-center">لا يُسترد أي مبلغ</td>
                            </tr>
                        </tbody>
                    </table>

                    <div className="font-bold mb-4 text-xs leading-tight">
                        <p>لا يجوز استرداد الرسوم الدراسية في الحالات التالية:</p>
                        <p>أ- سحب مقرر دراسي بعد انتهاء فترة الانسحاب الرسمي المقررة من الجامعة وفق التقويم الأكاديمي للجامعة.</p>
                        <p>ب- الانسحاب بسبب الحصول على إنذار عدم حضور، أو الانسحاب لسبب تأديبي، أو الفصل من الجامعة.</p>
                        <p>ج- تسجيل الطالب في المقررات دون 15 ساعة معتمدة في الفصل الدراسي.</p>
                        <p>د- لا يحق للطالب استرداد أية رسوم نتيجة حذف المواد دون الحد الأدنى (15) وحدة دراسية.</p>
                    </div>

                    <p className="text-red-700 font-bold border-b-2 border-red-700/40 pb-1.5 inline-block mb-4">3- سياسة استرداد الرسوم في حال الانسحاب من المقرر الدراسي (الفصل الصيفي)</p>
                    <table className="w-full border-collapse border border-black mb-4 text-center text-xs table-fixed" dir="rtl">
                        <thead>
                            <tr className="bg-[#b3b3b3] text-black font-bold text-center">
                                <th className="border border-black p-2 w-[45%] text-center">الفترة الزمنية</th>
                                <th className="border border-black p-2 w-[55%] text-center">استرداد الرسوم (الفصل الدراسي الصيفي)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="font-bold bg-white text-center">
                                <td className="border border-black p-2 leading-tight break-words text-center">أول 3 أيام (فترة الإضافة/الإسقاط) من الفصل الدراسي الصيفي</td>
                                <td className="border border-black p-2 leading-tight break-words text-center">استرداد 75% من المقرر المنسحب منه</td>
                            </tr>
                            <tr className="font-bold bg-[#f9f9f9] text-center">
                                <td className="border border-black p-2 leading-tight break-words text-center">اليوم الرابع و الخامس من الفصل الدراسي الصيفي</td>
                                <td className="border border-black p-2 leading-tight break-words text-center">استرداد 50% من المقرر المنسحب منه</td>
                            </tr>
                            <tr className="font-bold bg-white text-center">
                                <td className="border border-black p-2 leading-tight break-words text-center">خلال الأسبوع الثاني من الفصل الدراسي الصيفي</td>
                                <td className="border border-black p-2 leading-tight break-words text-center">استرداد 25% من المقرر المنسحب منه</td>
                            </tr>
                            <tr className="font-bold bg-[#f9f9f9] text-center">
                                <td className="border border-black p-2 leading-tight break-words text-center">الأسبوع الثالث من الفصل الدراسي الصيفي وما بعده</td>
                                <td className="border border-black p-2 leading-tight break-words text-center">لا يسترد أي مبلغ</td>
                            </tr>
                        </tbody>
                    </table>

                    <p className="text-red-700 font-bold border-b-2 border-red-700/40 pb-1.5 inline-block mb-4">4- سياسة استرداد الرسوم في حال الانسحاب من الجامعة</p>
                    <table className="w-full border-collapse border border-black mb-4 text-center text-xs table-fixed" dir="rtl">
                        <thead>
                            <tr className="bg-[#b3b3b3] text-black font-bold text-center">
                                <th className="border border-black p-2 w-[45%] text-center">الفترة الزمنية</th>
                                <th className="border border-black p-2 w-[55%] text-center">استرداد الرسوم (فصلي الربيع و الخريف)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="font-bold bg-white text-center">
                                <td className="border border-black p-2 leading-tight break-words text-center">خلال الأسبوع الأول (فترة الإضافة/السحب) من الفصل الدراسي</td>
                                <td className="border border-black p-2 leading-tight break-words text-center">استرداد 75% من الرسوم الدراسية للفصل الدراسي المنسحب منه</td>
                            </tr>
                            <tr className="font-bold bg-[#f9f9f9] text-center">
                                <td className="border border-black p-2 leading-tight break-words text-center">خلال الأسبوع الثاني من الفصل الدراسي</td>
                                <td className="border border-black p-2 leading-tight break-words text-center">استرداد 50% من الرسوم الدراسية للفصل الدراسي المنسحب منه</td>
                            </tr>
                            <tr className="font-bold bg-white text-center">
                                <td className="border border-black p-2 leading-tight break-words text-center">الأسبوع الثالث من الفصل الدراسي وما بعده</td>
                                <td className="border border-black p-2 leading-tight break-words text-center">لا يسترد أي مبلغ</td>
                            </tr>
                        </tbody>
                    </table>

                    <p className="text-red-700 font-bold border-b-2 border-red-700/40 pb-1.5 inline-block mb-4 leading-relaxed">5- سياسة استرداد الرسوم في حال تجميد الفصل الدراسي (وقف القيد):</p>
                    <table className="w-full border-collapse border border-black mb-4 text-center text-xs table-fixed" dir="rtl">
                        <thead>
                            <tr className="bg-[#b3b3b3] text-black font-bold text-center">
                                <th className="border border-black p-2 w-[45%] text-center">الفترة الزمنية</th>
                                <th className="border border-black p-2 w-[55%] text-center">استرداد الرسوم (فصلي الربيع و الخريف)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="font-bold bg-white text-center">
                                <td className="border border-black p-2 leading-tight break-words text-center">تقديم طلب وقف قيد قبل 10 أيام عمل من أول يوم لبدء الدراسة في الفصل الدراسي</td>
                                <td className="border border-black p-2 leading-tight break-words text-center">استرداد 100% من الرسوم الدراسية للفصل الدراسي المراد إيقافه</td>
                            </tr>
                            <tr className="font-bold bg-[#f9f9f9] text-center">
                                <td className="border border-black p-2 leading-tight break-words text-center">تقديم طلب وقف قيد في أي وقت بعد الوقت المحدد أعلاه</td>
                                <td className="border border-black p-2 leading-tight break-words text-center">لا يسترد أي مبلغ و يطالب بدفع الرسوم الدراسية كاملة</td>
                            </tr>
                        </tbody>
                    </table>

                    <p className="mb-2 font-bold text-xs">ملاحظات هامة: بخصوص تعليق التسجيل (وقف القيد الدراسي):</p>
                    <div className="pr-4 mb-4 text-xs font-bold leading-tight">
                        <p>- لا يجوز للطالب وقف قيده قبل الانتهاء من السنة الثانية من الدراسة بنجاح.</p>
                        <p>- يجب على الطالب الالتزام بالمواعيد النهائية لوقف القيد بالدراسة المبينة في دليل الطالب وفق الشروط والأحكام ووفق التقويم الأكاديمي للجامعة.</p>
                    </div>

                    {/* SIGNATURE BLOCK */}
                    <div className="pt-2 border-t-2 border-gray-200 mt-2" dir="rtl">
                        <div className="mb-6">
                            <div className="flex items-center gap-4 p-4 border-2 border-[#c1004f]/40 rounded-xl bg-[#c1004f]/5">
                                <div className="w-7 h-7 bg-[#c1004f] flex items-center justify-center rounded-md shadow-sm flex-shrink-0">
                                    <svg className="w-5 h-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="5">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                                    </svg>
                                </div>
                                <div className="flex-1 font-extrabold text-[12px] text-gray-900 leading-none py-1">
                                    I agreed to the terms and condition above / <span dir="rtl">أوافق على الشروط والأحكام المذكورة أعلاه</span>
                                </div>
                            </div>
                        </div>

                        <p className="text-xs font-bold mb-1" dir="rtl">إقرار بالعلم و الموافقة:</p>
                        <p className="mb-4 text-justify font-bold text-xs leading-relaxed" dir="rtl">أقر بأنني اطلعت على السياسة المالية أعلاه و أوافق على جميع ما جاء من الشروط و البنود أعلاه والالتزام بها في حال قبولي</p>

                        {/* Student section */}
                        <div className="space-y-1">
                            <div className="grid grid-cols-2 gap-16">
                                <SigField label="اسم الطالب:" value={`${formData.arabicFirstName?.value} ${formData.arabicMiddleName?.value} ${formData.arabicLastName?.value}`} variant="line" />
                                <SigField label="الرقم المدني للطالب:" value={formData.civilId?.value} isWideLabel variant="line" />
                            </div>

                            <SigField label="البريد الإلكتروني للطالب للتواصل:" value={formData.emailOne?.value} isWideLabel fullWidth variant="line" />

                            <div className="grid grid-cols-2 gap-16">
                                <SigField label="توقيع الطالب:" value="" lineColor="border-[#c1004f]" variant="line" />
                                <SigField label="التاريخ:" value="" variant="line" />
                            </div>
                        </div>

                        <p className="mb-3 text-justify font-bold text-xs leading-relaxed" dir="rtl">بصفتي ولي أمر الطالب اعلاه أقر بأنني اطلعت على السياسة المالية أعلاه وأوافق عليها وأتعهد بتسديد الرسوم الدراسية في تواريخ استحقاقها وألتزم باتباع جميع تعليمات وقوانين الجامعة ، وفي حال تغيير أي من البيانات أدناه أتعهد بإبلاغ قسم شؤون الطلبة بالجامعة.</p>

                        {/* Guardian section */}
                        <div className="space-y-1">
                            <div className="grid grid-cols-2 gap-16">
                                <SigField label="إسم ولي الأمر/ المقر:" value={formData.family?.arabicFatherName?.value} isWideLabel variant="line" />
                                <SigField label="الرقم المدني لولي الأمر:" value={formData.family?.fatherCivilId?.value} isWideLabel variant="line" />
                            </div>

                            <SigField label="العنوان:" value={guardianAddress} fullWidth variant="line" />

                            <div className="grid grid-cols-2 gap-16">
                                <SigField label="رقم الجوال :" value={formData.family?.fatherMobile?.value} variant="line" />
                                <SigField label="رقم الهاتف:" value={formData.family?.fatherWorkTel?.value} variant="line" />
                            </div>

                            <SigField label="البريد الإلكتروني:" value={formData.family?.fatherEmail?.value} fullWidth variant="line" />

                            <div className="grid grid-cols-2 gap-16">
                                <SigField label="توقيع ولي الأمر:" value="" isWideLabel lineColor="border-[#c1004f]" variant="line" />
                                <SigField label="التاريخ :" value="" variant="line" />
                            </div>
                        </div>
                    </div>
                </div>
            </PageContainer>

            {/* PAGE 11: FINAL ACKNOWLEDGMENT & FEES NOTICE */}
            <PageContainer pageNum={11}>
                <div className="px-8 pt-10">
                    <div className="py-4">
                        <p className="text-[11px] font-bold text-gray-800 leading-relaxed mb-8">
                            Selected applicants will be contacted only to continue on their application form and complete the needed fees payment.
                        </p>

                        <p className="text-[11px] font-bold text-gray-800 leading-relaxed mb-10">
                            Please Note: No application is considered a formal application without payment of application and admission tests / placement test fees. Payment of application fees and admission tests/placement test fees does not mean admission or acceptance into the University
                        </p>

                        <div className="flex items-center gap-4 mt-4">
                            <div className="w-5 h-5 bg-[#b60041] flex items-center justify-center rounded-sm">
                                <svg className="w-3.5 h-3.5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="5">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                                </svg>
                            </div>
                            <span className="text-[11px] font-bold text-gray-800">
                                I have read and agree to the above declaration
                            </span>
                        </div>
                    </div>
                </div>
            </PageContainer>
        </>
    );
};

export default FinancialPolicyPages;
